import { isValidPrice } from '@domain-group/javascript-utils'

export type InvoiceItemModel = {
  billing_type_id?: number,
  cache_key: number,
  data?: {
    xero_id?: number,
  },
  dates: any,
  description?: string,
  id: number,
  invoice_id: number,
  invoice_total?: number,
  price: number,
  provider_id: number,
  quantity: number,
  service_id: number,
  service_product_id: number,
  type: string,
  zuora_usage_id?: number,
}

export type InvoiceItemRequestOptions = {}

const state = {
  billing_type_id: undefined,
  description: '',
  id: null,
  invoice_id: undefined,
  price: '',
  provider_id: undefined,
  quantity: 1,
  service_id: undefined,
  service_product_id: undefined,
  type: '',
}

export const requiredFields = [
  { key: 'description' },
  { key: 'invoice_id' },
  { key: 'price', validation: isValidPrice },
]

export default state
